import React from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { authActionlogout } from '@laramie/ui';


function LogoutView(props) {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch( authActionlogout() );
        navigate('/login', { replace: true });
    }, [navigate]);

    return (
        <></>
    )
}

export default LogoutView;
